import { render } from "./BookMarkButton.vue?vue&type=template&id=c2fd2804&scoped=true&ts=true"
import script from "./BookMarkButton.vue?vue&type=script&lang=ts"
export * from "./BookMarkButton.vue?vue&type=script&lang=ts"

import "./BookMarkButton.vue?vue&type=style&index=0&id=c2fd2804&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2fd2804"]])

export default __exports__